// Colors
export const colors = {
    woodsmoke: "#121919",
    celtic: "#102C21",
    outerSpace: "#2a3e36",
    japaneseLaurel: "#146a04",
    japaneseLaurel2: "#308808",
    japaneseLaurel3: "#298008",
    japaneseLaurel4: "#196703",
    japaneseLaurel5: "#2c8801",
    mintGreen: "#9fffa6",
    limeade: "#3b9a00",
    cascade: "#8baea0",
    skeptic: "#b6dece",
    skeptic2: "#d3eadf",
    mountainMeadow: "#1DB954",
    funGreen: "#02853f",
    jade: "#00cb5e",
    turbo: "#f3e200",
    goldenSand: "#f2d86d",
    husk: "#bdab5b",
    portica: "#f0cd56",
    white: "#ffffff",
    black: "#000000",
    capeCod: "#384040",
    mineshaft: "#363636",
    alto: "#d8d8d8",
    doveGray: "#707070",
    scorpion: "#5e5e5e",
    pumice: "#c0c5c3",
    coralRed: "#FF4242",
    sunsetOrange: "#ff4b4b",
    havelockBlue: "#4A90E2",
    westSide: "#FF9211",
    ebonyClay: "#20283b",
    aztec: "#2c3433",
    parsley: "#124D24"
};

export const themeIddaa = {
    name: "İddaa tv theme",
    colors: {
        primary: colors.funGreen,
        secondary: colors.turbo,
        color1: colors.woodsmoke,
        color2: colors.celtic,
        color3: colors.outerSpace,
        color4: colors.japaneseLaurel,
        color5: colors.japaneseLaurel2,
        color6: colors.japaneseLaurel3,
        color7: colors.japaneseLaurel4,
        color8: colors.mintGreen,
        color9: colors.limeade,
        color10: colors.cascade,
        color11: colors.skeptic,
        color12: colors.skeptic2,
        color13: colors.mountainMeadow,
        color14: colors.jade,
        color15: colors.goldenSand,
        color16: colors.husk,
        color17: colors.portica,
        color18: colors.white,
        color19: colors.black,
        color20: colors.capeCod,
        color21: colors.mineshaft,
        color22: colors.alto,
        color23: colors.doveGray,
        color24: colors.scorpion,
        color25: colors.pumice,
        color26: colors.coralRed,
        color27: colors.sunsetOrange,
        color28: colors.havelockBlue,
        color29: colors.westSide,
        color30: colors.ebonyClay,
        color31: colors.aztec,
        color32: colors.parsley,
        color33: colors.japaneseLaurel5
    }
};

export const themeAz = {
    name: "Az tv theme",
    colors: {
        primary: "#ffffff",
        secondary: "#000000",
        color2: colors.mintGreen,
    }
};
